import React, { useState } from 'react';
import axios from 'Axios';
import { api, toastify, clx } from 'Utils';
import { ModalBox, Button, SubmitButton } from 'Elements';
import styles from 'partials/modalbox/modal-form.module.scss';
import contentStyles from 'partials/dashboard/user-content.module.scss';
import { Trash } from 'tabler-icons-react';

export const ModalBoxDeleteContent = React.memo(
	({ isOpen, onClose, size, onDelete, story }) => {
		const [state, setState] = useState({
			isSubmiting: false
		});

		const handleSubmit = (e) => {
			e.preventDefault();

			const data = {
				production_id: story.id
			};
			setState((prev) => ({
				...prev,
				isSubmiting: true
			}));

			axios.post(api.deleteStory, data).then((res) => {
				const data = res.data;

				setState((prev) => ({
					...prev,
					isSubmiting: false
				}));
				if (data.success) {
					toastify('محتوای مورد نظر با موفقیت حذف شد', 'success');
					onDelete?.();
					onClose();
				} else {
					toastify(data.message);
				}
			});
		};

		return (
			<ModalBox isOpen={isOpen} onClose={onClose} size={size}>
				<div className={contentStyles.selectedBox}>
					<Trash
						size="36"
						color="#FF6868"
						strokeWidth={1.5}
						className={contentStyles.selectedIcon}
					/>
					<div className={contentStyles.body}>
						<h3 className={contentStyles.selectedTitle}>
							عنوان محتوا
						</h3>
						<span
							className={clx(
								contentStyles.textOverflow,
								contentStyles.selectedText
							)}>
							{story.story.title}
						</span>
					</div>
				</div>
				<form className={styles.form} onSubmit={handleSubmit}>
					<p className={contentStyles.textBody}>
						از حذف محتوای انتخاب شده مطمئن هستید؟
					</p>
					<div className={clx(styles.fieldBox, 'mt-30')}>
						<Button onClick={onClose} className={styles.submit}>
							خیر
						</Button>
						<SubmitButton
							className={clx(
								styles.btnBorder,
								styles.btnBorderRed
							)}
							title="بله، حذف شود"
							disabledTitle="در حال حذف"
							disabled={state.isSubmiting}
						/>
					</div>
				</form>
			</ModalBox>
		);
	}
);

ModalBoxDeleteContent.displayName = 'ModalBoxDeleteContent';
